import { render, staticRenderFns } from "./MemoryItem.vue?vue&type=template&id=002fcdd8&scoped=true&"
import script from "./MemoryItem.vue?vue&type=script&lang=js&"
export * from "./MemoryItem.vue?vue&type=script&lang=js&"
import style0 from "./MemoryItem.vue?vue&type=style&index=0&id=002fcdd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002fcdd8",
  null
  
)

export default component.exports